module.exports = __webpack_public_path__ + "img/spribe.824e7685.jpeg";